// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc dependencies
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { grey75 } from '@zocdoc/branding/colors';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
const DoctorLocation = ({ className, location = {}, style }) => {
    const { address1, address2, address3, city, state, zipCode } = location;
    const addresses = [address1, address2, address3].filter(Boolean);
    let streetAddress = null;
    if (addresses.length) {
        streetAddress = (
            <span
                data-test="lightweight-doctor-card-info-location-address"
                itemProp="streetAddress"
            >
                {addresses.join(', ')}
            </span>
        );
    }
    const addressLocality = city ? (
        <span
            data-test="lightweight-doctor-card-info-location-city"
            itemProp="addressLocality"
        >
            {city}
        </span>
    ) : null;

    const addressRegion = state ? (
        <span
            data-test="lightweight-doctor-card-info-location-state"
            itemProp="addressRegion"
        >
            {state}
        </span>
    ) : null;

    const postalCode = zipCode ? (
        <span
            data-test="lightweight-doctor-card-info-location-zip"
            itemProp="postalCode"
        >
            {zipCode}
        </span>
    ) : null;

    const remainingAddress =
        addressLocality || addressRegion || postalCode ? (
            <span>
                {addressLocality}
                {addressRegion}
                {postalCode}
            </span>
        ) : null;

    if (!streetAddress && !remainingAddress) {
        return null;
    }

    return (
        <LocationText
            className={className}
            data-test="lightweight-doctor-card-doctor-location-text"
            style={style}
        >
            {streetAddress}
            {remainingAddress}
        </LocationText>
    );
};

const LocationText = styled.div`
    height: auto;
    font-family: ${FontFamily.SharpSansSemibold};
    line-height: 1.38;
    color: ${grey75};
    margin-top: 4px;
    font-size: 13px;
    ${breakpoint.medium} {
        font-size: 14px;
    }

    span:not(:last-of-type)::after {
        content: ', ';
    }
`;

export default DoctorLocation;
